import { Github, Twitter, Linkedin, Send } from 'lucide-react'
import { ScrollReveal } from '@/components/shared/ScrollReveal'
import { connectContent, connectLinks, identity } from '@/content/portfolio'

const socialIcons: Record<string, React.ReactNode> = {
  github: <Github className="w-5 h-5" aria-hidden="true" />,
  twitter: <Twitter className="w-5 h-5" aria-hidden="true" />,
  linkedin: <Linkedin className="w-5 h-5" aria-hidden="true" />,
  telegram: <Send className="w-5 h-5" aria-hidden="true" />,
}

export function Connect() {
  return (
    <section id="connect" className="scroll-mt-24 py-16 lg:py-24 bg-vibe-black">
      <div className="max-w-4xl mx-auto px-4 lg:px-8 text-center">
        <ScrollReveal>
          <h2 className="text-2xl lg:text-4xl font-medium text-text-heading mb-4">
            {connectContent.title}
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={0.1}>
          <p className="text-base lg:text-lg text-text-secondary mb-8">
            {connectContent.intro}
          </p>
        </ScrollReveal>

        <ScrollReveal delay={0.15}>
          <div className="flex flex-wrap justify-center gap-4 mb-8">
            <a href={`mailto:${identity.email}`} className="flex items-center px-4 py-2 lg:py-4 border border-accent-primary rounded-lg text-accent-primary hover:bg-accent-primary/10">Email me</a>
            {connectLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-4 py-2 lg:px-4 lg:py-4 border border-vibe-border rounded-lg text-text-secondary hover:text-accent-primary hover:border-accent-primary transition-colors"
                aria-label={`${link.label} (opens in new tab)`}
              >
                {socialIcons[link.icon as keyof typeof socialIcons]}
                <span className="text-sm lg:text-base">{link.label}</span>
              </a>
            ))}
          </div>
        </ScrollReveal>

        <ScrollReveal delay={0.2}>
          <p className="font-mono text-accent-primary text-base lg:text-lg">
            {connectContent.motto}
          </p>
        </ScrollReveal>
      </div>
    </section>
  )
}
